import React from "react";
import clsx from "clsx";

import MobileTab from "@material/react-tab";
import MobileTabBar from "@material/react-tab-bar";
import "@material/react-tab-bar/dist/tab-bar.css";
import "@material/react-tab-scroller/dist/tab-scroller.css";
import "@material/react-tab/dist/tab.css";
import "@material/react-tab-indicator/dist/tab-indicator.css";

import useStyles from "./styles";

interface IProps {
  tabs: string[];
  activeIndex: number;
  onActiveTabChange: (value: number) => void;
  className?: string;
}

const ScrollableMobileTabBar = (props: IProps) => {
  const { tabs, activeIndex, onActiveTabChange, className } = props;

  const classes = useStyles();

  const tabsContent = tabs.map((tab: string, index: number) => {
    const activeMobileTab = index + 1;

    return (
      <MobileTab key={activeMobileTab} data-index={activeMobileTab}>
        <span className={"mdc-tab__text-label"}>{tab}</span>
      </MobileTab>
    );
  });

  return (
    <MobileTabBar
      className={clsx(classes.tabBar, className)}
      activeIndex={activeIndex}
      handleActiveIndexUpdate={onActiveTabChange}
    >
      {tabsContent}
    </MobileTabBar>
  );
};

export default React.memo(ScrollableMobileTabBar);
